export const projectsData = [
  {
    projectName: "Quiz Check!",
    projectDescription:
      "Wanna test you knowledge! You can try quiz check the best quiz platform",
    imageUrl:
      "https://scontent.fdel24-1.fna.fbcdn.net/v/t1.6435-9/70342277_108682847171988_9175853562368884736_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=EkFzpGO5bjkAX_IsGgV&_nc_ht=scontent.fdel24-1.fna&oh=00_AT8lN1Zc5QCEVPDCmxm1dL5h0GD_xChFSn85_AN5F-RQ8w&oe=62B14E58",
    repoUrl: "https://github.com/ritesh423/QuizCheck",
  },
  {
    projectName: "Todo-Advance",
    projectDescription:
      "A todo list app with some additional pages other than todo and some additional features too .",
    imageUrl:
      "https://scontent.fdel24-1.fna.fbcdn.net/v/t1.6435-9/70342277_108682847171988_9175853562368884736_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=EkFzpGO5bjkAX_IsGgV&_nc_ht=scontent.fdel24-1.fna&oh=00_AT8lN1Zc5QCEVPDCmxm1dL5h0GD_xChFSn85_AN5F-RQ8w&oe=62B14E58",
    repoUrl: "https://github.com/ritesh423/TodoList",
  },

  {
    projectName: "R-Clothing",
    projectDescription:
      "R-Clothing is a clothing app with too many features like payment checkout sign in signup most of the features youll find in a full fleged clothing app",
    imageUrl:
      "https://scontent.fdel24-1.fna.fbcdn.net/v/t1.6435-9/70342277_108682847171988_9175853562368884736_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=EkFzpGO5bjkAX_IsGgV&_nc_ht=scontent.fdel24-1.fna&oh=00_AT8lN1Zc5QCEVPDCmxm1dL5h0GD_xChFSn85_AN5F-RQ8w&oe=62B14E58",
    repoUrl: "https://github.com/ritesh423/R-Clothing",
  },
  {
    projectName: "Portfolio Website",
    projectDescription:
      "As a developer/designer, you should definitely have your own portfolio website. There are endless benefits. But, a lot of people feel that it would be tough to make one. So here I bring you a tutorial to make your own website.",
    imageUrl:
      "https://scontent.fdel24-1.fna.fbcdn.net/v/t1.6435-9/70342277_108682847171988_9175853562368884736_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=EkFzpGO5bjkAX_IsGgV&_nc_ht=scontent.fdel24-1.fna&oh=00_AT8lN1Zc5QCEVPDCmxm1dL5h0GD_xChFSn85_AN5F-RQ8w&oe=62B14E58",
    repoUrl: "https://github.com/ritesh423/Portfolio",
  },
];
